import { Outlet } from "react-router-dom";

import { Footer } from "../components/footer";
import { Header } from "../components/header";
import { AccountProvider } from "../components/account/context";
import { GlossaryProvider } from "../components/glossary/context";
import { SiteProvider } from "./context";
import { SiteModal } from "./site-modal";
import { ClinicalAccountProvider } from "../components/account/clinical-context";
import { GoogleAnalytics } from "../components/google-analytics";
import { Hotjar } from "../components/hotjar";

const Layout = () => {
  return (
    <SiteProvider>
      <GlossaryProvider>
        <ClinicalAccountProvider>
          <AccountProvider>
            <Header />
            <Outlet />
            <Footer />
            <SiteModal />
            <GoogleAnalytics />
            <Hotjar />
          </AccountProvider>
        </ClinicalAccountProvider>
      </GlossaryProvider>
    </SiteProvider>
  );
};

export default Layout;
